import { t } from "../setup/i18n-setup"

export const Configurations = {
    inject: ['settings'],
    data() {
        return {
            pickerOptions: {

            },
            datePickerShortcuts: [
                {
                    text: t('datePicker.today'),
                    value: new Date(),
                },
                {
                    text: t('datePicker.lastDay'),
                    value: () => {
                        const date = new Date()
                        date.setTime(date.getTime() - 3600 * 1000 * 24)
                        return date
                    },
                },
                {
                    text: t('datePicker.weekAgo'),
                    value: () => {
                        const date = new Date()
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                        return date
                    },
                },
            ],
            datePickerRangeYearShortcuts: [
                {
                    text: t('datePicker.previousYear'),
                    value: () => {
                        const end = new Date(new Date().getFullYear() - 1, 11, 31)
                        const start = new Date(new Date().getFullYear() - 1, 0, 1)
                        return [start, end]
                    },
                },
                {
                    text: t('datePicker.thisYear'),
                    value: () => {
                        const end = new Date(new Date().getFullYear(), 11, 31)
                        const start = new Date(new Date().getFullYear(), 0, 1)
                        return [start, end]
                    },
                },
                {
                    text: t('datePicker.nextYear'),
                    value: () => {
                        const end = new Date(new Date().getFullYear() + 1, 11, 31)
                        const start = new Date(new Date().getFullYear() + 1, 0, 1)
                        return [start, end]
                    },
                },
            ],
            datePickerRangeShortcuts: [
                {
                    text: t('datePicker.lastDay'),
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
                        return [start, end]
                    },
                },
                {
                    text: t('datePicker.lastWeek'),
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        return [start, end]
                    },
                },
                {
                    text: t('datePicker.last2Weeks'),
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
                        return [start, end]
                    },
                },
                {
                    text: t('datePicker.lastMonth'),
                    value: () => {
                        var start = new Date();
                        const end = new Date(start.getFullYear(), start.getMonth(), 0);
                        start = new Date(start.getFullYear(), start.getMonth() - 1, 1);
                        return [start, end]
                    },
                },
                {
                    text: t('datePicker.last3Months'),
                    value: () => {
                        var start = new Date();
                        const end = new Date(start.getFullYear(), start.getMonth(), 0);
                        start = new Date(start.getFullYear(), start.getMonth() - 3, 1);
                        return [start, end]
                    },
                },
                {
                    text: t('datePicker.last6Months'),
                    value: () => {
                        var start = new Date();
                        const end = new Date(start.getFullYear(), start.getMonth(), 0);
                        start = new Date(start.getFullYear(), start.getMonth() - 6, 1);
                        return [start, end]
                    },
                },
            ],
            datePickerRangeShortcutsFuture: [
                {
                    text: t('datePicker.nextDay'),
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() + 3600 * 1000 * 24 * 1)
                        end.setTime(end.getTime() + 3600 * 1000 * 24 * 1)
                        return [start, end]
                    },
                },
                {
                    text: t('datePicker.nextMonth'),
                    value: () => {
                        var start = new Date();
                        const end = new Date(start.getFullYear(), start.getMonth() + 2, 0);
                        start = new Date(start.getFullYear(), start.getMonth() + 1, 1);
                        return [start, end]
                    },
                },
                {
                    text: t('datePicker.next3Months'),
                    value: () => {
                        var start = new Date();
                        const end = new Date(start.getFullYear(), start.getMonth() + 4, 0);
                        start = new Date(start.getFullYear(), start.getMonth() + 1, 1);
                        return [start, end]
                    },
                },
                {
                    text: t('datePicker.next6Months'),
                    value: () => {
                        var start = new Date();
                        const end = new Date(start.getFullYear(), start.getMonth() + 7, 0);
                        start = new Date(start.getFullYear(), start.getMonth() + 1, 1);
                        return [start, end]
                    },
                },
                {
                    text: t('datePicker.nextYear'),
                    value: () => {
                        var start = new Date();
                        const end = new Date(start.getFullYear(), start.getMonth() + 13, 0);
                        start = new Date(start.getFullYear(), start.getMonth() + 1, 1);
                        return [start, end]
                    },
                },
            ],
            configuration: {
                showSearch: true,
                showSearchPanel: true,
                showExpandColumn: true,
                showSelectionColumn: true,
                showQuickSearch: true,
                showBreadcrumb: true,
                showBaseSearchPanel: true,
                showMainSearch: true,
            },
        };
    },
    computed: {
        isDemo() {
            return this.settings.ENVIRONMENT == "DEMO";
        },
    },
    methods: {
        t,
        disableFarDates: function (date) {
            return date < new Date(2020, 1, 1) || date > new Date(2030, 1, 1);
        },
        setBrowserTabName: function (pageName, specific) {
            try {
                var tabName = this.settings.DEFAULT_BROWSER_TAB_NAME != null ? this.settings.DEFAULT_BROWSER_TAB_NAME : 'Trade 24';

                if (pageName != null && pageName.length > 0) {
                    var translatedPageName = t('pages.' + pageName);
                    if (translatedPageName != null && !translatedPageName.startsWith('pages.')) {
                        tabName = tabName + " - " + translatedPageName;
                    };
                };

                if (specific != null && specific.length > 0) {
                    tabName = tabName + " - " + specific;
                };

                return tabName;
            }
            catch (exception) {
                return "Trade 24";
            }
        },
    }

}